import { uniqBy } from 'lodash';

const DEFAULT_STATE = {};

export default function directoryTagsReducer(state, action) {
    if (!state) {
        state = { ...DEFAULT_STATE };
    }

    switch (action.type) {
        case 'UPDATE_DIRECTORY_TAGS':
            for (let tag of action.tags) {
                state = {
                    ...state,
                    [action.directoryId]: uniqBy([...action.tags, ...(state[action.directoryId] ?? [])], 'name'),
                };
            }
            break;
    }

    return state;
}
